export default {
  person: {
    type: 'juridica',
  },
};
